export function NumberConverter({ number }) {
    const formattedNumber = Number(number).toFixed(2);
    return <>{formattedNumber}</>;
  }